/**
 * Staff clock portal link.
 *
 * One portal serves both this app and the Shopify app, and it chooses WHICH
 * BACKEND to call from the shopDomain it is opened with: a `.myshopify.com`
 * suffix routes it to the Shopify backend.
 *
 * So the suffix must NOT be added here. The Shopify app's copy of this helper
 * appends it deliberately; doing the same in this app would hand our users'
 * clock-ins to the wrong API. The handle is passed through exactly as the
 * Dashboard already sends it.
 */
const DEFAULT_PORTAL_URL = 'https://portal.zonstaff.com';

const PORTAL_BASE_URL = String(
  import.meta.env?.VITE_CLOCK_PORTAL_URL || DEFAULT_PORTAL_URL
).replace(/\/+$/, '');

/**
 * Build the portal URL for an account. Returns '' when the handle is not known
 * yet, so callers can avoid rendering a broken link during load.
 */
export const buildPortalUrl = (shop) => {
  const handle = String(shop || '').trim();
  if (!handle) return '';
  return `${PORTAL_BASE_URL}/?shopDomain=${encodeURIComponent(handle)}`;
};

export default buildPortalUrl;
